// Vista semanal de disponibilidad. Pinta los patrones (recurrentes) como bloques en un grid 7×N.

import styles from './WeeklyView.module.scss';
import type { AvailabilityPattern } from '@/services/availability';

interface WeeklyViewProps {
  patterns: AvailabilityPattern[];
  startHour?: number;
  endHour?: number;
}

const WEEKDAYS_ES = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];

function timeToMin(t: string): number {
  const [h, m] = t.split(':');
  return Number(h) * 60 + Number(m);
}

export function WeeklyView({ patterns, startHour = 8, endHour = 22 }: WeeklyViewProps) {
  const dayStart = startHour * 60;
  const dayEnd = endHour * 60;
  const dayMins = dayEnd - dayStart;

  const hourLabels: number[] = [];
  for (let h = startHour; h <= endHour; h++) hourLabels.push(h);

  const blocksByDay: AvailabilityPattern[][] = [[], [], [], [], [], [], []];
  for (const p of patterns) {
    if (p.weekday >= 0 && p.weekday <= 6) blocksByDay[p.weekday]!.push(p);
  }

  return (
    <div className={styles.wrap}>
      <div className={styles.hours}>
        <div className={styles.hourSpacer} />
        {hourLabels.map((h) => (
          <div key={h} className={styles.hourLabel}>{String(h).padStart(2, '0')}:00</div>
        ))}
      </div>
      <div className={styles.grid}>
        {WEEKDAYS_ES.map((label, idx) => (
          <div key={label} className={styles.column}>
            <div className={styles.colHead}>{label}</div>
            <div className={styles.colBody}>
              {blocksByDay[idx]!.map((p) => {
                const startMin = timeToMin(p.start_time);
                const endMin = timeToMin(p.end_time);
                const top = Math.max(0, ((startMin - dayStart) / dayMins) * 100);
                const height = Math.max(0, ((Math.min(endMin, dayEnd) - Math.max(startMin, dayStart)) / dayMins) * 100);
                return (
                  <div
                    key={p.id}
                    className={styles.block}
                    style={{ top: `${top}%`, height: `${height}%` }}
                    title={`${p.start_time.slice(0, 5)}–${p.end_time.slice(0, 5)}`}
                  >
                    <span>{p.start_time.slice(0, 5)}</span>
                    <span>{p.end_time.slice(0, 5)}</span>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
